/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Gateway_Spending_Cap_Reset_InfoInputs */



/**
* | output |
* | --- |
* | "Period resets: {date}" |
*
* @param {Gateway_Spending_Cap_Reset_InfoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_spending_cap_reset_info = /** @type {((inputs: Gateway_Spending_Cap_Reset_InfoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Spending_Cap_Reset_InfoInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Periode endet: ${i?.date}`)
	return /** @type {LocalizedString} */ (`Period resets: ${i?.date}`)
});